module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-force-rebook"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Attachment translations")]), (_vm.show) ? _c('div', {
    staticClass: "row column"
  }, [_vm._l((_vm.allowedLanguages), function(lang) {
    return [_c('label', [_vm._v(_vm._s(lang))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.translation[lang]),
        expression: "translation[lang]"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.translation[lang])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.translation, lang, $event.target.value)
        }, function($event) {
          return _vm.$emit('input', _vm.translation)
        }]
      }
    })]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd11faae!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/TocAttachmentTranslationReveal.vue
// module id = 2710
// module chunks = 1